import React from 'react';
import { Helmet } from 'react-helmet-async';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <Helmet>
        <title>Hakkımızda | Erşan Döviz - 32+ Yıl Güvenilir Döviz Hizmeti</title>
        <meta name="description" content="Erşan Döviz Hakkımızda - 2003'ten beri İzmir'de güvenilir döviz hizmeti. Yetkili müessese A grubu lisanslı. Misyonumuz, vizyonumuz ve değerlerimiz." />
        <meta name="keywords" content="Erşan Döviz hakkımızda, döviz bürosu tarihçe, İzmir döviz deneyim, yetkili müessese, A grubu lisans, misyon vizyon, güvenilir döviz hizmeti, Erşan hikaye" />
        <link rel="canonical" href="https://ersandoviz.com/hakkimizda" />
        <meta property="og:title" content="Hakkımızda | Erşan Döviz - 15+ Yıl Deneyim" />
        <meta property="og:description" content="Erşan Döviz Hakkımızda - 2003'ten beri İzmir'de güvenilir döviz hizmeti. Yetkili müessese A grubu lisanslı." />
        <meta property="og:url" content="https://ersandoviz.com/hakkimizda" />
        <meta property="og:type" content="website" />
      </Helmet>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content text-center">
            <h1 className="about-title">Hakkımızda</h1>
            <p className="about-subtitle">
              Güvenilir döviz hizmetleri ile 32+ yıldan fazla süredir yanınızdayız
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="story-content">
                <h2 className="story-title">
                  Hikayemiz
                </h2>
                <p className="story-text">
                  Erşan Döviz Bürosu, 1993 yılında kurulduğundan bu yana müşterilerine 
                  güvenilir ve profesyonel döviz hizmetleri sunmaktadır. Sektördeki 
                  deneyimimiz ve müşteri odaklı yaklaşımımızla, binlerce müşterinin 
                  güvenini kazanmış bulunuyoruz.
                </p>
                <p className="story-text">
                  Kuruluşumuzdan itibaren, döviz piyasasındaki değişimleri yakından 
                  takip ederek müşterilerimize en güncel ve avantajlı kurları sunmayı 
                  hedefledik. Bu doğrultuda, teknolojik gelişmeleri takip ederek 
                  hizmet kalitemizi sürekli artırmaktayız.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Vision Section */}
      <section className="mission-vision section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="mission-card card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#missionGradient)"/>
                    <defs>
                      <linearGradient id="missionGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#f093fb"/>
                        <stop offset="100%" stopColor="#f5576c"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="card-title">Misyonumuz</h3>
                <p className="card-text">
                  Müşterilerimize en güvenilir, hızlı ve avantajlı döviz hizmetlerini 
                  sunarak, finansal ihtiyaçlarını karşılamada güvenilir bir partner 
                  olmak. Şeffaf ve dürüst hizmet anlayışımızla sektörde öncü olmayı 
                  hedefliyoruz.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="vision-card card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="url(#visionGradient)" strokeWidth="2" fill="none"/>
                    <circle cx="12" cy="12" r="3" stroke="url(#visionGradient)" strokeWidth="2" fill="none"/>
                    <defs>
                      <linearGradient id="visionGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#4facfe"/>
                        <stop offset="100%" stopColor="#00f2fe"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="card-title">Vizyonumuz</h3>
                <p className="card-text">
                  Türkiye'nin en güvenilir ve tercih edilen döviz bürosu olmak. 
                  Teknolojik yenilikleri takip ederek, müşteri deneyimini sürekli 
                  geliştirmek ve sektörde standartları belirleyen bir kurum haline 
                  gelmek.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values section-padding">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Değerlerimiz</h2>
            <p className="section-description">
              Hizmet anlayışımızın temelini oluşturan değerlerimiz
            </p>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="value-item">
                <div className="value-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="value-title">Güvenilirlik</h4>
                <p className="value-description">
                  Müşterilerimizin güvenini kazanmak ve korumak için her zaman 
                  dürüst ve şeffaf davranırız.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="value-item">
                <div className="value-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                    <path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="value-title">Hızlılık</h4>
                <p className="value-description">
                  Zamanın değerini bilerek, tüm işlemlerinizi en kısa sürede 
                  tamamlamaya odaklanırız.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="value-item">
                <div className="value-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="value-title">Müşteri Odaklılık</h4>
                <p className="value-description">
                  Müşteri memnuniyetini her şeyin üstünde tutarak, ihtiyaçlarınıza 
                  özel çözümler sunarız.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;